import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-message-bar',
  templateUrl: './message-bar.component.html',
  styleUrls: ['./message-bar.component.css']
})
export class MessageBarComponent implements OnInit {

  @Input() type:string = null;
  @Input() message:string = null;
  
  constructor() { }

  ngOnInit() {
    console.log('type',this.type)
  }

}
